import { jsxs as p, jsx as r } from "react/jsx-runtime";
import { c as t } from "../../../clsx-OuTLNxxd.js";
const x = "_title_1s6y9_29", f = "_subtitle_1s6y9_106", s = {
  "title-container": "_title-container_1s6y9_29",
  "color-inverted": "_color-inverted_1s6y9_32",
  "is-primary": "_is-primary_1s6y9_35",
  "is-secondary": "_is-secondary_1s6y9_38",
  "is-tertiary": "_is-tertiary_1s6y9_41",
  "is-success": "_is-success_1s6y9_44",
  "is-error": "_is-error_1s6y9_47",
  "is-eco-green": "_is-eco-green_1s6y9_50",
  title: x,
  "is-1": "_is-1_1s6y9_61",
  "is-impact": "_is-impact_1s6y9_70",
  "is-2": "_is-2_1s6y9_74",
  "is-3": "_is-3_1s6y9_84",
  "text-align-left": "_text-align-left_1s6y9_94",
  "text-align-right": "_text-align-right_1s6y9_97",
  "text-align-center": "_text-align-center_1s6y9_100",
  "text-align-justify": "_text-align-justify_1s6y9_103",
  subtitle: f,
  "dialog-overlay-show": "_dialog-overlay-show_1s6y9_1",
  "dialog-content-show": "_dialog-content-show_1s6y9_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1s6y9_1"
}, h = {
  default: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "color-inverted"
};
function w({
  color: a = "default",
  children: o,
  level: e = 3,
  hasHeaderTag: n = !1,
  isImpact: c,
  subtitle: i,
  className: l = "",
  title: y,
  textAlign: _,
  ...d
}) {
  const g = `h${e}`, u = `${n ? g : "p"}`, m = t(
    s.title,
    s[`is-${e}`],
    c && s["is-impact"],
    _ && s[`text-align-${_}`],
    l
  );
  return /* @__PURE__ */ p("div", { className: t(s["title-container"], s[h[a]]), children: [
    /* @__PURE__ */ r(u, { className: m, ...d, title: y, children: o }),
    i && /* @__PURE__ */ r("p", { className: t(s.subtitle), children: i })
  ] });
}
export {
  w as Title
};
